<template>
  <van-popup class="tip-modal" v-model="show" :close-on-click-overlay="false">
    <div class="container">
      <div class="header">
        <div class="icon">
          <img src="@/assets/img/tip-icon.png" alt="">
        </div>
        <p class="title">{{ options.title || '提示' }}</p>
      </div>
      <div class="content">
        <p v-if="options.message">{{ options.message }}</p>
        <slot name="content"></slot>
      </div>
      <div class="footer">
        <div class="btn cancel" v-if="!options.cancelHide" @click="cencelHandle">{{ options.cancelText || '取消' }}</div>
        <div class="btn confirm" @click="confirmHandle">{{ options.confirmText || '确定' }}</div>
      </div>
    </div>
    <div class="close-btn" v-if="!options.closeHide" @click="close">×</div>
  </van-popup>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => { }
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    },
    confirmHandle() {
      this.$emit('confirm');
    },
    cencelHandle() {
      this.$emit('cancel');
    }
  }
}
</script>

<style lang="less" scoped>
.van-popup {
  background: linear-gradient(180deg, #f7bb94 0%, #f7ae9a 100%);
  border-radius: 0.2rem;
  padding: 0.1rem;
  overflow: unset;
  min-width: 2.5rem;
  max-width: 80%;
  .container {
    background: linear-gradient(180deg, #ffdeb9 0%, #fff7ee 100%);
    box-shadow: 0 0 0.2rem 1px rgba(191, 41, 0, 0.62);
    border-radius: 0.16rem;
    padding: 0.1rem 0.2rem 0.26rem;
    .header {
      text-align: center;
      .icon {
        width: 0.48rem;
        height: 0.48rem;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        font-size: 0.16rem;
        font-weight: bold;
        color: #d45500;
      }
    }
    .content {
      font-size: 0.16rem;
      color: #5a3600;
      text-align: center;
      margin-top: 0.1rem;
      line-height: 1.7;
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.2rem;
      .btn {
        width: 0.85rem;
        height: 0.34rem;
        line-height: 0.34rem;
        font-size: 0.15rem;
        margin: 0 0.1rem;
        text-align: center;
        &.cancel {
          background: url("~@/assets/img/cancel-btn2.png") center/100% 100%
            no-repeat;
          color: #630200;
        }
        &.confirm {
          background: url("~@/assets/img/confirm-btn2.png") center/100% 100%
            no-repeat;
          color: #fff;
        }
      }
    }
  }
  .close-btn {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.22rem;
    text-align: center;
    background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
    border: 1px solid #ffd98b;
    border-radius: 50%;
    color: #fff;
    font-size: 0.2rem;
    cursor: pointer;
  }
}
</style>